import requestv2 from "~/utils/http-v2";

const createdWebsiteApi = {
	gets : async (params) => {
		const url = 'v2/created-website';
		return await requestv2.get(url, {params});
	},
	template : async (params) => {
		const url = 'v2/created-website/template';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/created-website';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/created-website/${params.id}`;
		return await requestv2.post(url, params);
	},
	reInsert : async (id) => {
		const url = `v2/created-website/re-insert/${id}`;
		return await requestv2.post(url);
	},
	status : async (params) => {
		const url = `v2/created-website/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	delete : async (id) => {
		const url = `v2/created-website/${id}`;
		return await requestv2.delete(url);
	}
};

export default createdWebsiteApi;